import VesselService from '../services/vessel.service';
import { Vessel } from './models/models';

export default {
  namespaced: true,
  state: {
    vesselId: null,
  },
  mutations: {
    vesselId(state, vesselId) {
      state.vesselId = vesselId;
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('getVessels');
    },
    newVessel({ commit }) {
      Vessel.new()
        .then((vessel) => {
          commit('vesselId', vessel.id);
        });
    },
    updateVesselProps({ state }, props) {
      Vessel.update({
        where: state.vesselId,
        data: props,
      });
    },
    getVessels() {
      return VesselService.getVessels()
        .then((res) => {
          Vessel.create({ data: res });
        });
    },
    getVessel({ commit }, id) {
      return VesselService.getVessel(id)
        .then((vessel) => {
          Vessel.insert({ data: [vessel] })
            .then(() => {
              commit('vesselId', vessel.id);
            });
        });
    },
    createVessel({ getters }) {
      return VesselService.createVessel(getters.vessel);
    },
    updateVessel({ getters, dispatch }) {
      return VesselService.updatePackage(getters.vessel)
        .then((res) => {
          if (res.hasOwnProperty('vessel_id')) {
            dispatch('getVessel', res.vessel_id);
          }
          return res;
        });
    },
    deleteVessel({ getters }) {
      return VesselService.deleteVessel(getters.vessel)
        .then((res) => {
          if (res.hasOwnProperty('vessel_id')) {
            Vessel.delete(res.vessel_id);
          }
          return res;
        });
    },
  },
  getters: {
    vessels() {
      return Vessel.all();
    },
    vessel(state) {
      if (!state.vesselId) {
        return null;
      }
      return Vessel.query()
        .find(state.vesselId);
    },
  },
};
